import View from './previewView.js';
import { previewView } from './previewView.js';
import icons from 'url:../../img/icons.svg';

class BookmarksView extends View {
  _parentElement = document.querySelector('.bookmarks');
  _errorMessage = 'No bookmarks yet. Find a nice recipe and bookmark it :)';
  _message = '';

  addHandlerRender(handler) {
    window.addEventListener('load', handler);
  }

  addHandlerShowRecipe(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--show-recipe');
      if (!btn) return;
      const id = btn.dataset.recipeId;
      if (id) handler(id);
    });
  }

  addHandlerRemoveBookmark(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--remove-bookmark');
      if (!btn) return;
      const id = btn.dataset.recipeId;
      if (id) handler(id);
    });
  }

  _generateMarkup() {
    return `
      <ul class="bookmarks__list">
        ${this._data.map(bookmark => {
          const previewMarkup = previewView.render(bookmark, false);
          // Insert actions before closing </li> tag
          const actionsMarkup = `
            <div class="preview__actions">
              <button class="btn--bookmark-action btn--show-recipe" data-recipe-id="${bookmark.id}">
                <svg>
                  <use href="${icons}#icon-arrow-right"></use>
                </svg>
                <span>Show recipe</span>
              </button>
              <button class="btn--bookmark-action btn--remove-bookmark" data-recipe-id="${bookmark.id}">
                <svg>
                  <use href="${icons}#icon-alert-circle"></use>
                </svg>
                <span>Remove</span>
              </button>
            </div>
          `;
          // Replace closing </li> with actions + </li>
          return previewMarkup.replace('</li>', `${actionsMarkup}</li>`);
        }).join('')}
      </ul>
    `;
  }
}

export default new BookmarksView();

